<nz-spin [nzSpinning]="loading$ | async">
  <form nz-form class="form" nzLayout="horizontal" [formGroup]="userForm">
    <div class="drawer-form-wrapper">
      <nz-form-item>
        <nz-upload
          [nzFileList]="fileList"
          [nzBeforeUpload]="beforeUpload"
          [nzShowUploadList]="true"
          [nzIconRender]="iconTemplate"
          nzListType="picture"
          [nzRemove]="handleFileRemove"
          [nzMultiple]="false"
          [nzAccept]="'.xls,.xlsx'"
          nzDrop
          class="file-upload">
          <button nz-button type="button">
            <div class="upload-icon">
              <svg-icon
                [title]="'Upload File'"
                src="/assets/icon/icon-upload.svg"
                class="icon s-12"
                aria-label="Upload">
              </svg-icon>
            </div>
            <div class="wrapper">
              <p class="text s-14 fw-600 green">
                Click to upload
                <span class="text s-14 fw-400">or drag and drop</span>
              </p>
              <p class="text s-12 fw-400">XLS, XLSX files only</p>
            </div>
          </button>
          <app-upload-progress
            [progress$]="uploadProgress$"></app-upload-progress>
        </nz-upload>
      </nz-form-item>
      <div class="btn-wrapper-end">
        <a
          href="/assets/samplefiles/SampleStudentImportFile.xlsx"
          download="SampleStudentImportFile.xlsx"
          nz-button
          nzType="text"
          class="primary-text-btn">
          Sample Import File
        </a>
      </div>

      <div class="display-flex justify-content-between drawer-footer">
        <button nz-button nzType="default" (click)="closeImportDrawer()">
          Cancel
        </button>
        <button
          type="button"
          (click)="submitForm()"
          nz-button
          [disabled]="fileList.length === 0"
          [nzLoading]="loading$ | async"
          nzType="primary">
          Import Students
        </button>
      </div>
    </div>
  </form>
</nz-spin>
<ng-template #iconTemplate let-file>
  <svg-icon
    src="/assets/icon/icon-xls.svg"
    class="icon s-12"
    aria-label="Xls"></svg-icon>
</ng-template>
